import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../utils/dateFormat';
import { DocsPageHeader } from '../../../components/docs/DocsPageHeader';

export function TermsOfServiceContent() {
  const { t } = useTranslation('docs');

  return (
    <div className="space-y-8">
      <DocsPageHeader
        badge={t('sidebar.policies')}
        title={t('policies.tos.heading')}
        description={t('policies.tos.last_updated', { date: formatDate(new Date()) })}
      />

      <section className="space-y-6">
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.tos.s1_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.tos.s1_text')}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.tos.s2_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.tos.s2_text')}
          </p>
          <ul className="list-disc space-y-2 pl-5 text-sm text-muted-foreground">
            <li>{t('policies.tos.s2_item1')}</li>
            <li>{t('policies.tos.s2_item2')}</li>
            <li>{t('policies.tos.s2_item3')}</li>
            <li>{t('policies.tos.s2_item4')}</li>
          </ul>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.tos.s3_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.tos.s3_text')}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.tos.s4_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.tos.s4_text')}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.tos.s5_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.tos.s5_text')}
          </p>
          <ul className="list-disc space-y-2 pl-5 text-sm text-muted-foreground">
            <li>{t('policies.tos.s5_item1')}</li>
            <li>{t('policies.tos.s5_item2')}</li>
            <li>{t('policies.tos.s5_item3')}</li>
            <li>{t('policies.tos.s5_item4')}</li>
            <li>{t('policies.tos.s5_item5')}</li>
            <li>{t('policies.tos.s5_item6')}</li>
          </ul>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.tos.s6_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.tos.s6_text')}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.tos.s7_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.tos.s7_text')}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.tos.s8_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.tos.s8_text')}
          </p>
        </div>
      </section>
    </div>
  );
}

export function PrivacyPolicyContent() {
  const { t } = useTranslation('docs');

  return (
    <div className="space-y-8">
      <DocsPageHeader
        badge={t('sidebar.policies')}
        title={t('policies.privacy.heading')}
        description={t('policies.privacy.last_updated', { date: formatDate(new Date()) })}
      />

      <section className="space-y-6">
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.privacy.s1_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.privacy.s1_text')}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.privacy.s2_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.privacy.s2_text')}
          </p>
          <ul className="list-disc space-y-2 pl-5 text-sm text-muted-foreground">
            <li>{t('policies.privacy.s2_item1')}</li>
            <li>{t('policies.privacy.s2_item2')}</li>
            <li>{t('policies.privacy.s2_item3')}</li>
            <li>{t('policies.privacy.s2_item4')}</li>
            <li>{t('policies.privacy.s2_item5')}</li>
          </ul>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.privacy.s3_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.privacy.s3_text')}
          </p>
          <ul className="list-disc space-y-2 pl-5 text-sm text-muted-foreground">
            <li>{t('policies.privacy.s3_item1')}</li>
            <li>{t('policies.privacy.s3_item2')}</li>
            <li>{t('policies.privacy.s3_item3')}</li>
            <li>{t('policies.privacy.s3_item4')}</li>
          </ul>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.privacy.s4_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.privacy.s4_text')}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.privacy.s5_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.privacy.s5_text')}
          </p>
          <ul className="list-disc space-y-2 pl-5 text-sm text-muted-foreground">
            <li>{t('policies.privacy.s5_item1')}</li>
            <li>{t('policies.privacy.s5_item2')}</li>
            <li>{t('policies.privacy.s5_item3')}</li>
            <li>{t('policies.privacy.s5_item4')}</li>
            <li>{t('policies.privacy.s5_item5')}</li>
          </ul>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.privacy.s6_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.privacy.s6_text')}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.privacy.s7_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.privacy.s7_text')}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.privacy.s8_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.privacy.s8_text')}
          </p>
        </div>

        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-foreground">{t('policies.privacy.s9_title')}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">
            {t('policies.privacy.s9_text')}
          </p>
        </div>
      </section>
    </div>
  );
}

